import React, { useContext } from 'react'
import { Handle } from 'react-flow-renderer'
import { NodesContext } from '../provider/IvrContext'

const AnswerNode = ({ data }) => {
    const { nodeConnections } = useContext(NodesContext)
    const outgoingCount = nodeConnections?.["new-target-handle"]?.length ?? 0
    const disabled = outgoingCount >= 1;
    return (
        <div
            className="ivr-flow-node"
            style={{
                width: "75px",
                height: "40px",
                border: "2px solid green",
                background: "#fff",
                position: "relative",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            {/* Handle */}
            <Handle
                type="source"
                position="bottom"
                id="new-target-handle"
                style={{
                    position: "absolute",
                    backgroundColor: "green",
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    bottom: "-4px",
                    left: "50%",
                    transform: "translateX(-50%)",
                }}
                isConnectable={!disabled}
            />

            {/* Node Label */}
            <div
                className="ivr-flow-node-label"
                style={{
                    fontSize: "10px",
                    fontWeight: "bold",
                    color: "#333",
                    textAlign: "center",
                    textTransform: "capitalize",
                }}
            >
                {data.label}
            </div>
        </div>
    )
}

export default AnswerNode